(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glow-pdp"] && !Shopify.designMode) return;
  try {
    
/* Independent of the theme's cart and product form. Reconnects in the theme editor. */
if (!customElements.get('lv-glow-pdp')) {
  class GlowPdp extends HTMLElement {
    connectedCallback() {
      if (this._active) return;
      this._active = true;
      this._abort = new AbortController();
      this._cleanups = [];
      this._motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._listen = (node, event, callback, options = {}) => node.addEventListener(event, callback, { ...options, signal: this._abort.signal });
      this.setupTabs();
      this.setupControls();
      this.setupCarousel();
      this.setupDialogs();
      this.setupMotion();
      this.setupTutorialVideo();
      this._listen(this, 'click', (event) => {
        const link = event.target.closest('[data-return-to-product]');
        if (!link) return;
        const target = document.querySelector('product-info') || document.getElementById('MainContent');
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: this._motion.matches ? 'instant' : 'smooth', block: 'start' });
        const focusTarget = target.querySelector('h1') || target;
        const oldTabindex = focusTarget.getAttribute('tabindex');
        focusTarget.setAttribute('tabindex', '-1');
        focusTarget.focus({ preventScroll: true });
        focusTarget.addEventListener('blur', () => {
          if (oldTabindex === null) focusTarget.removeAttribute('tabindex');
          else focusTarget.setAttribute('tabindex', oldTabindex);
        }, { once: true });
      });
      this._listen(this, 'shopify:block:select', (event) => {
        const block = event.target.closest('[data-block-id]');
        if (!block) return;
        if (block.hasAttribute('data-tab-panel')) this.selectTab?.(Number(block.dataset.tabPanel));
        if (block.hasAttribute('data-control-tab')) this.selectControl?.(block.dataset.controlTab);
        if (block.hasAttribute('data-slide')) this.scrollToSlide?.(Array.from(this.querySelectorAll('[data-slide]')).indexOf(block));
      });
      this.classList.add('is-ready');
    }
    disconnectedCallback() {
      this._abort?.abort();
      this._cleanups?.forEach(cleanup => cleanup());
      this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
      this._active = false;
    }
    setupTabs() {
      const tabs = Array.from(this.querySelectorAll('[data-tab]'));
      const panels = Array.from(this.querySelectorAll('[data-tab-panel]'));
      if (!tabs.length || tabs.length !== panels.length) return;
      let active = 0;
      this.selectTab = (index, focus = false) => {
        active = (index + tabs.length) % tabs.length;
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === active));
          tab.tabIndex = i === active ? 0 : -1;
          panels[i].hidden = i !== active;
        });
        const count = this.querySelector('[data-tab-count]');
        if (count) count.textContent = `${active + 1} / ${tabs.length}`;
        const nav = tabs[active].parentElement;
        const tabRect = tabs[active].getBoundingClientRect();
        const navRect = nav.getBoundingClientRect();
        if (tabRect.left < navRect.left || tabRect.right > navRect.right) {
          nav.scrollBy({ left: tabRect.left - navRect.left - (navRect.width - tabRect.width) / 2, behavior: this._motion.matches ? 'instant' : 'smooth' });
        }
        if (focus) tabs[active].focus({ preventScroll: true });
      };
      tabs.forEach((tab, index) => {
        this._listen(tab, 'click', () => this.selectTab(index));
        this._listen(tab, 'keydown', event => {
          let indexToSelect;
          if (event.key === 'ArrowRight') indexToSelect = active + 1;
          if (event.key === 'ArrowLeft') indexToSelect = active - 1;
          if (event.key === 'Home') indexToSelect = 0;
          if (event.key === 'End') indexToSelect = tabs.length - 1;
          if (indexToSelect === undefined) return;
          event.preventDefault();
          this.selectTab(indexToSelect, true);
        });
      });
      this.querySelectorAll('[data-tab-step]').forEach(button => this._listen(button, 'click', () => this.selectTab(active + Number(button.dataset.tabStep))));
      const swipe = this.querySelector('[data-swipe-panels]');
      let start = null;
      this._listen(swipe, 'touchstart', event => {
        start = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
      }, { passive: true });
      this._listen(swipe, 'touchend', event => {
        if (!start || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - start.x;
        const dy = event.changedTouches[0].clientY - start.y;
        if (Math.abs(dx) > 60 && Math.abs(dy) < 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.selectTab(active + (dx < 0 ? 1 : -1));
        start = null;
      }, { passive: true });
      this._listen(swipe, 'touchcancel', () => { start = null; }, { passive: true });
      this.selectTab(0);
    }
    setupControls() {
      const tabs = Array.from(this.querySelectorAll('[data-control-tab]'));
      const panels = Array.from(this.querySelectorAll('[data-control-panel]'));
      if (!tabs.length || tabs.length !== panels.length) return;
      const labels = Array.from(this.querySelectorAll('[data-control-label]'));
      const lines = Array.from(this.querySelectorAll('[data-control-line]'));
      let active = 0;
      this.selectControl = (id, focus = false) => {
        const index = tabs.findIndex(tab => tab.dataset.controlTab === id);
        if (index < 0) return;
        active = index;
        tabs.forEach((tab, i) => {
          const selected = i === active;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          panels[i].setAttribute('role', 'tabpanel');
          panels[i].setAttribute('aria-labelledby', tab.id);
          panels[i].setAttribute('aria-hidden', String(!selected));
          panels[i].tabIndex = selected ? 0 : -1;
          panels[i].inert = !selected;
        });
        labels.forEach(label => label.classList.toggle('is-active', label.dataset.controlLabel === id));
        lines.forEach(line => line.classList.toggle('is-active', line.dataset.controlLine === id));
        if (focus) tabs[active].focus({ preventScroll: true });
      };
      tabs.forEach(tab => {
        this._listen(tab, 'click', () => this.selectControl(tab.dataset.controlTab));
        this._listen(tab, 'keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (active + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (active - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.selectControl(tabs[next].dataset.controlTab, true);
        });
      });
      const selected = tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || tabs[0];
      this.selectControl(selected.dataset.controlTab);
      this.classList.add('has-inline-controls');
    }
    setupCarousel() {
      const track = this.querySelector('[data-track]');
      if (!track) return;
      const slides = Array.from(track.querySelectorAll('[data-slide]'));
      const dots = Array.from(this.querySelectorAll('[data-dot]'));
      const previous = this.querySelector('[data-scroll="-1"]');
      const next = this.querySelector('[data-scroll="1"]');
      let current = 0, frame = 0;
      const offsets = () => {
        const trackRect = track.getBoundingClientRect();
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        return slides.map(slide => Math.min(max, Math.max(0, slide.getBoundingClientRect().left - trackRect.left + track.scrollLeft)));
      };
      const update = () => {
        frame = 0;
        const positions = offsets();
        current = positions.reduce((best, position, index) => Math.abs(position - track.scrollLeft) < Math.abs(positions[best] - track.scrollLeft) ? index : best, 0);
        dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === current)));
        if (previous) previous.disabled = !slides.length || current === 0;
        if (next) next.disabled = !slides.length || current === slides.length - 1;
      };
      this.scrollToSlide = index => {
        if (!slides.length) return;
        const selected = Math.max(0, Math.min(index, slides.length - 1));
        track.scrollTo({ left: offsets()[selected], behavior: this._motion.matches ? 'instant' : 'smooth' });
      };
      this.querySelectorAll('[data-scroll]').forEach(button => this._listen(button, 'click', () => this.scrollToSlide(current + Number(button.dataset.scroll))));
      dots.forEach((dot, index) => this._listen(dot, 'click', () => this.scrollToSlide(index)));
      this._listen(track, 'scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, { passive: true });
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(update);
        observer.observe(track);
        this._cleanups.push(() => observer.disconnect());
      }
      this._cleanups.push(() => cancelAnimationFrame(frame));
      update();
    }
    setupDialogs() {
      const dialogs = Array.from(this.querySelectorAll('dialog'));
      if (!dialogs.length || typeof dialogs[0].showModal !== 'function') return;
      this.classList.add('has-dialogs');
      const openers = new Map();
      this._listen(this, 'click', event => {
        const trigger = event.target.closest('[data-open-dialog]');
        if (trigger) {
          const dialog = dialogs.find(item => item.id === trigger.dataset.openDialog);
          if (!dialog) return;
          event.preventDefault();
          openers.set(dialog, trigger);
          dialog.showModal();
          dialog.querySelector('[data-close-dialog]')?.focus();
          return;
        }
        if (event.target.closest('[data-close-dialog]')) event.target.closest('dialog')?.close();
      });
      dialogs.forEach(dialog => {
        this._listen(dialog, 'click', event => {
          if (event.target !== dialog) return;
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
        });
        this._listen(dialog, 'close', () => {
          dialog.querySelectorAll('video').forEach(video => video.pause());
          const opener = openers.get(dialog);
          if (opener?.isConnected) opener.focus({ preventScroll: true });
          openers.delete(dialog);
        });
      });
    }
    setupTutorialVideo() {
      const player = this.querySelector('[data-tutorial-player]');
      if (!player) return;
      const video = player.querySelector('video');
      const cover = player.querySelector('[data-tutorial-play]');
      const status = player.querySelector('[data-tutorial-video-status]');
      if (!video || !cover) return;
      const oldTabindex = video.getAttribute('tabindex');
      const signal = this._abort.signal;
      let focusPlayback = false;
      const restoreTabindex = () => {
        if (oldTabindex === null) video.removeAttribute('tabindex');
        else video.setAttribute('tabindex', oldTabindex);
      };
      const showCover = () => {
        cover.hidden = false;
        cover.disabled = false;
        cover.removeAttribute('aria-busy');
        video.setAttribute('aria-hidden', 'true');
        video.setAttribute('tabindex', '-1');
      };
      const showError = () => {
        if (signal.aborted) return;
        showCover();
        if (status) status.hidden = false;
      };
      showCover();
      this._listen(cover, 'click', () => {
        focusPlayback = document.activeElement === cover;
        if (status) status.hidden = true;
        cover.disabled = true;
        cover.setAttribute('aria-busy', 'true');
        if (video.error) video.load();
        video.play().catch(showError);
      });
      this._listen(video, 'playing', () => {
        const moveFocus = focusPlayback;
        focusPlayback = false;
        cover.hidden = true;
        cover.disabled = false;
        cover.removeAttribute('aria-busy');
        if (status) status.hidden = true;
        video.removeAttribute('aria-hidden');
        video.setAttribute('tabindex', '0');
        if (moveFocus) video.focus({ preventScroll: true });
      });
      this._listen(video, 'ended', () => {
        const moveFocus = document.activeElement === video;
        showCover();
        if (moveFocus) cover.focus({ preventScroll: true });
      });
      this._listen(video, 'error', showError);
      this._cleanups.push(() => {
        video.pause();
        video.removeAttribute('aria-hidden');
        restoreTabindex();
        cover.hidden = true;
      });
    }
    setupMotion() {
      const toggle = this.querySelector('[data-motion-toggle]');
      if (!toggle) return;
      this._listen(toggle, 'click', () => {
        const paused = this.classList.toggle('is-paused');
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.textContent = paused ? toggle.dataset.resume : toggle.dataset.pause;
      });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => entries.forEach(entry => this.classList.toggle('is-in-view', entry.isIntersecting)), { threshold: .1 });
        observer.observe(this);
        this._cleanups.push(() => observer.disconnect());
      } else this.classList.add('is-in-view');
    }
  }
  customElements.define('lv-glow-pdp', GlowPdp);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lv-audio-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lv-audio-cards')) {
    customElements.define('lv-audio-cards', class extends HTMLElement {
      static current = null;
      connectedCallback() {
        this.start = requestAnimationFrame(() => this.init());
      }
      init() {
        if (!this.isConnected || this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.track = this.querySelector('.lvac__track');
        this.navigation = this.querySelector('.lvac__navigation');
        this.status = this.querySelector('.lvac__status');
        this.cards = Array.from(this.querySelectorAll('.lvac__card'));
        this.serial = 0;
        this.detail = this.querySelector('.lvac__detail');
        this.playerButton = this.querySelector('.lvac__player-toggle');
        this.seek = this.querySelector('.lvac__seek');
        this.playerButton.addEventListener('click', () => { if(this.selectedCard) this.toggle(this.selectedCard); }, {signal});
        this.seek.addEventListener('input', () => {
          const audio = this.selectedCard?.querySelector('audio');
          if(audio && Number.isFinite(audio.duration) && audio.duration > 0) audio.currentTime = Number(this.seek.value) / 1000 * audio.duration;
          this.syncPlayer();
        }, {signal});
        this.querySelector('.lvac__close').addEventListener('click', () => {
          const selected = this.selectedCard;
          this.stop();
          this.detail.hidden = true;
          this.selectedCard = null;
          this.cards.forEach(card => { card.classList.remove('is-selected'); card.querySelector('button').setAttribute('aria-expanded','false'); });
          selected?.querySelector('button').focus({preventScroll:true});
        }, {signal});
        this.cards.forEach(card => {
          const audio = card.querySelector('audio');
          const button = card.querySelector('.lvac__trigger');
          button.disabled = false;
          button.setAttribute('aria-controls', this.detail.id);
          button.setAttribute('aria-expanded', 'false');
          button.addEventListener('click', () => { this.select(card); if(audio) this.toggle(card); }, {signal});
          if (!audio) return;
          audio.addEventListener('loadedmetadata', () => this.syncPlayer(), {signal});
          audio.addEventListener('durationchange', () => this.syncPlayer(), {signal});
          audio.addEventListener('playing', () => {
            if (this.currentCard !== card) { audio.pause(); return; }
            this.paint(card, 'playing');
          }, { signal });
          audio.addEventListener('waiting', () => {
            if (this.currentCard === card) this.paint(card, 'loading');
          }, { signal });
          audio.addEventListener('pause', () => {
            if (audio.paused && this.currentCard === card) this.stop();
          }, { signal });
          audio.addEventListener('ended', () => {
            if (this.currentCard === card) this.stop();
            card.style.setProperty('--lvac-progress', '0');
          }, { signal });
          audio.addEventListener('error', () => { if (this.currentCard === card) this.fail(card); }, { signal });
          audio.addEventListener('timeupdate', () => {
            const value = Number.isFinite(audio.duration) && audio.duration > 0 ? audio.currentTime / audio.duration : 0;
            this.syncPlayer();
            card.style.setProperty('--lvac-progress', String(Math.min(1, Math.max(0, value))));
          }, { signal });
        });
        this.navigation.addEventListener('click', event => {
          const button = event.target.closest('[data-direction]');
          if (!button) return;
          const width = this.cards[0]?.getBoundingClientRect().width || 240;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          this.track.scrollBy({ left: (width + gap) * Number(button.dataset.direction) * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }, { signal });
        this.refresh = () => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const position = Math.abs(this.track.scrollLeft);
          this.navigation.hidden = max <= 3;
          this.navigation.querySelector('[data-direction="-1"]').disabled = position <= 3;
          this.navigation.querySelector('[data-direction="1"]').disabled = position >= max - 3;
        };
        this.track.addEventListener('scroll', this.refresh, { passive: true, signal });
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.stop(); }, { signal });
        window.addEventListener('pagehide', () => this.stop(), { signal });
        document.addEventListener('shopify:block:select', event => {
          const card = this.cards.find(item => item.dataset.blockId === event.detail.blockId);
          if (card) card.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'auto' });
        }, { signal });
        this.observer = new ResizeObserver(this.refresh);
        this.observer.observe(this.track);
        this.classList.add('is-ready');
        this.refresh();
      }
      select(card) {
        if(this.selectedCard !== card) this.stop();
        this.selectedCard = card;
        this.cards.forEach(item => {
          item.classList.toggle('is-selected', item === card);
          item.querySelector('button').setAttribute('aria-expanded', String(item === card));
        });
        this.querySelector('.lvac__detail-title').textContent = card.dataset.title;
        const description = this.querySelector('.lvac__detail-description');
        description.textContent = card.dataset.description || '';
        description.hidden = !description.textContent;
        this.detail.hidden = false;
        this.syncPlayer();
      }
      syncPlayer() {
        if(!this.playerButton) return;
        const audio = this.selectedCard?.querySelector('audio');
        const duration = audio && Number.isFinite(audio.duration) ? audio.duration : 0;
        const current = audio?.currentTime || 0;
        const playing = audio && !audio.paused && !audio.ended;
        this.playerButton.disabled = !audio;
        this.playerButton.textContent = playing ? 'Ⅱ' : '▶';
        this.playerButton.setAttribute('aria-label', playing ? this.dataset.pause : this.dataset.play);
        this.seek.disabled = !duration;
        this.seek.value = duration ? current / duration * 1000 : 0;
        const format = value => `${Math.floor(value/60)}:${String(Math.floor(value%60)).padStart(2,'0')}`;
        this.querySelector('.lvac__time').textContent = `${format(current)} / ${format(duration)}`;
        this.seek.setAttribute('aria-valuetext', `${format(current)} of ${format(duration)}`);
        this.querySelector('.lvac__player-note').textContent = !audio ? this.dataset.unavailable : audio.error ? this.dataset.error : this.dataset.previewNote;
      }
      paint(card, state) {
        const active = state !== 'paused';
        card.classList.toggle('is-playing', state === 'playing');
        card.classList.toggle('is-loading', state === 'loading');
        const button = card.querySelector('.lvac__trigger');
        button.setAttribute('aria-pressed', String(active));
        button.setAttribute('aria-label', `${active ? this.dataset.pause : this.dataset.play}: ${card.dataset.title}`);
        this.syncPlayer();
        this.status.textContent = `${state === 'loading' ? this.dataset.loading : (active ? this.dataset.play : this.dataset.pause)}: ${card.dataset.title}`;
      }
      stop() {
        this.serial++;
        const card = this.currentCard;
        this.currentCard = null;
        if (this.constructor.current === this) this.constructor.current = null;
        if (!card) return;
        card.querySelector('audio')?.pause();
        this.paint(card, 'paused');
      }
      fail(card) {
        if (this.currentCard !== card) return;
        this.stop();
        const error = card.querySelector('.lvac__error');
        error.textContent = this.dataset.error;
        error.hidden = false;
        this.status.textContent = this.dataset.error;
      }
      async toggle(card) {
        if (this.currentCard === card) { this.stop(); return; }
        this.constructor.current?.stop();
        this.currentCard = card;
        this.constructor.current = this;
        const ticket = ++this.serial;
        const audio = card.querySelector('audio');
        card.querySelector('.lvac__error').hidden = true;
        if (audio.ended) audio.currentTime = 0;
        if (audio.error) audio.load();
        this.paint(card, 'loading');
        try {
          await audio.play();
          if (ticket !== this.serial || this.currentCard !== card) return;
          this.paint(card, 'playing');
        } catch (error) {
          if (ticket === this.serial && this.currentCard === card) this.fail(card);
        }
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.start);
        this.stop();
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = null;
        this.classList.remove('is-ready');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lv-scroll-overlay"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lv-scroll-overlay')) {
    customElements.define('lv-scroll-overlay', class extends HTMLElement {
      connectedCallback() {
        this.startFrame = requestAnimationFrame(() => this.init());
      }
      init() {
        if (!this.isConnected || this.controller) return;
        this.slides = Array.from(this.querySelectorAll('.lvso__slide'));
        if (!this.slides.length) return;
        this.frame = this.querySelector('.lvso__frame');
        this.buttons = Array.from(this.querySelectorAll('[data-step]'));
        this.shared = document.createElement('div');
        this.shared.className = 'lvso__shared';
        this.shared.style.cssText = this.slides[0].style.cssText;
        const sharedCopy = this.slides[0].querySelector('.lvso__copy').cloneNode(true);
        sharedCopy.querySelectorAll('.lvso__step, .lvso__body, .lvso__link').forEach(node => node.remove());
        const stepGrid = document.createElement('div');
        stepGrid.className = 'lvso__steps';
        this.stepCopies = this.slides.map(slide => {
          const item = document.createElement('div');
          item.className = 'lvso__step-copy';
          slide.querySelectorAll('.lvso__step, .lvso__body, .lvso__link').forEach(node => item.append(node.cloneNode(true)));
          item.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
          stepGrid.append(item);
          return item;
        });
        sharedCopy.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
        sharedCopy.append(stepGrid);
        this.shared.append(sharedCopy);
        this.frame.append(this.shared);
        this.sectionRoot = this.closest('.shopify-section') || this;
        this.parentObserver = new MutationObserver(() => { this.bridge(); this.queue(); });
        if (this.sectionRoot.parentElement) this.parentObserver.observe(this.sectionRoot.parentElement, { childList: true });
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.mobile = matchMedia('(max-width: 767px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.editorIndex = null;
        this.queue = () => {
          if (!this.tick) this.tick = requestAnimationFrame(() => { this.tick = 0; this.update(); });
        };
        this.measure = () => {
          this.isStatic = this.slides.length < 2 || this.reduced.matches || (this.mobile.matches && this.dataset.mobile !== 'true');
          this.classList.toggle('is-static', this.isStatic);
          if (this.mobile.matches) {
            const header = document.querySelector('.header-section');
            const sticky = header?.querySelector('[is="sticky-header"]');
            const headerHeight = header && (sticky || ['sticky','fixed'].includes(getComputedStyle(header).position))
              ? header.getBoundingClientRect().height : 0;
            this.style.setProperty('--lvso-header-clearance', `${Math.ceil(headerHeight)}px`);
          } else this.style.removeProperty('--lvso-header-clearance');
          const frameHeight = this.frame.getBoundingClientRect().height;
          const unit = Math.max(1, parseFloat(getComputedStyle(this).getPropertyValue('--lvso-distance')) || 80);
          this.travel = this.isStatic ? 0 : Math.max(1, frameHeight * this.slides.length * unit / 100);
          this.style.setProperty('--lvso-rail-height', `${frameHeight + this.travel}px`);
          // Fit the whole copy without an inner scroll area. Reserve space for navigation.
          const copyHeight = Math.max(1, sharedCopy.scrollHeight);
          const pad = Math.min(24, frameHeight * .04);
          const bottom = this.buttons.length ? 74 : pad;
          const scale = Math.min(1, Math.max(1, frameHeight - pad - bottom) / copyHeight);
          const desiredY = parseFloat(getComputedStyle(this.shared).getPropertyValue('--lvso-y')) || 50;
          const half = copyHeight * scale / 2;
          const copyTop = Math.max(pad + half, Math.min(frameHeight - bottom - half, frameHeight * desiredY / 100));
          this.shared.style.setProperty('--lvso-copy-scale', String(scale));
          this.shared.style.setProperty('--lvso-copy-top', `${copyTop}px`);
          this.bridge();
          this.queue();
        };
        this.classList.add('is-ready');
        window.addEventListener('scroll', this.queue, { passive: true, signal });
        window.addEventListener('resize', this.measure, { passive: true, signal });
        this.mobile.addEventListener('change', this.measure, { signal });
        this.reduced.addEventListener('change', this.measure, { signal });
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-step]');
          if (!button || !this.contains(button) || this.isStatic) return;
          this.editorIndex = null;
          const index = Number(button.dataset.step);
          const top = this.getBoundingClientRect().top + window.scrollY - this.offset();
          window.scrollTo({ top: top + this.travel * (index + .15) / this.slides.length, behavior: 'auto' });
          this.queue();
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.editorIndex = index;
          if (this.isStatic) this.slides[index].scrollIntoView({ block: 'center' });
          else window.scrollTo({ top: this.getBoundingClientRect().top + window.scrollY - this.offset(), behavior: 'auto' });
          this.queue();
        }, { signal });
        document.addEventListener('shopify:block:deselect', event => {
          if (this.slides.some(slide => slide.dataset.blockId === event.detail.blockId)) { this.editorIndex = null; this.queue(); }
        }, { signal });
        const dock = document.querySelector('.mobile-dock');
        if (dock) {
          this.dockObserver = new MutationObserver(this.queue);
          this.dockObserver.observe(dock, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
          dock.addEventListener('transitionend', this.queue, { signal });
        }
        this.observer = new ResizeObserver(this.measure);
        this.observer.observe(this.frame);
        this.observer.observe(sharedCopy);
        this.measure();
      }
      offset() {
        return parseFloat(getComputedStyle(this.frame).top) || 0;
      }
      bridge(cleanup = false) {
        // Native sticky positioning keeps the next section attached to the image
        // on the compositor, with no per-scroll translations or timing lag.
        const root = this.sectionRoot;
        const parent = root?.parentElement;
        this.parentObserver?.disconnect();
        if (cleanup || this.isStatic || !parent) {
          if (this.tailInner) this.observer?.unobserve(this.tailInner);
          if (this.tail?.parentElement) {
            const holder = this.tail.parentElement;
            while (this.tailInner.firstChild) holder.insertBefore(this.tailInner.firstChild, this.tail);
            this.tail.remove();
          }
          this.tail = this.tailInner = null;
        } else {
          const siblings = [];
          for (let node = root.nextElementSibling; node; node = node.nextElementSibling) {
            if (node !== this.tail) siblings.push(node);
          }
          if (siblings.length && !this.tail) {
            this.tail = document.createElement('div');
            this.tail.className = 'lvso-tail';
            this.tailInner = document.createElement('div');
            this.tailInner.className = 'lvso-tail__inner';
            this.tail.append(this.tailInner);
            root.after(this.tail);
            this.observer?.observe(this.tailInner);
          }
          if (this.tail) {
            siblings.forEach(node => this.tailInner.append(node));
            this.tail.style.setProperty('--lvso-tail-height', `${this.tailInner.offsetHeight}px`);
            this.tail.style.setProperty('--lvso-tail-travel', `${this.travel}px`);
            this.tail.style.setProperty('--lvso-tail-top', `${this.offset() + this.frame.getBoundingClientRect().height}px`);
          }
        }
        if (!cleanup && parent) this.parentObserver?.observe(parent, { childList: true });
      }
      update() {
        if (!this.isConnected) return;
        if (this.isStatic) {
          this.slides.forEach(slide => {
            slide.inert = false;
            slide.removeAttribute('aria-hidden');
            slide.style.removeProperty('--lvso-opacity');
            slide.style.removeProperty('--lvso-scale');
          });
          this.shared.inert = true;
          this.classList.remove('is-mobile-pinned');
          return;
        }
        this.shared.inert = false;

        if (this.mobile.matches) {
          const dock = document.querySelector('.mobile-dock');
          const style = dock ? getComputedStyle(dock) : null;
          const box = dock?.getBoundingClientRect();
          const height = box && style.display !== 'none' && style.visibility === 'visible' && Number(style.opacity) > 0
            ? Math.max(0, Math.min(box.height, this.frame.getBoundingClientRect().bottom - box.top)) : 0;
          this.style.setProperty('--lvso-visible-dock', `${height}px`);
        }
        const rect = this.getBoundingClientRect();
        this.classList.toggle('is-mobile-pinned', this.mobile.matches && rect.top <= this.offset() + 1 && rect.bottom > this.offset());
        const count = this.slides.length;
        const progress = Math.max(0, Math.min(1, (this.offset() - this.getBoundingClientRect().top) / this.travel));
        const position = Math.min(count - .00001, progress * count);
        const base = Math.floor(position);
        const blend = base === count - 1 ? 0 : Math.max(0, Math.min(1, (position - base - .65) / .35));
        const smooth = t => t * t * (3 - 2 * t);
        const eased = smooth(blend);
        const selected = this.editorIndex;
        const active = selected !== null ? selected : (blend >= .5 ? base + 1 : base);
        this.style.setProperty('--lvso-progress', String(selected !== null ? (selected + 1) / count : progress));
        this.slides.forEach((slide, i) => {
          // Keep the outgoing image opaque under the incoming image to avoid a dark dip.
          const opacity = selected !== null ? (i === selected ? 1 : 0) : (i === base ? 1 : (i === base + 1 ? eased : 0));
          const local = selected !== null ? 0 : Math.max(0, Math.min(1, position - i));
          slide.style.setProperty('--lvso-opacity', String(opacity));
          slide.style.setProperty('--lvso-scale', String(this.mobile.matches ? 1 : 1 + .02 * local));
          slide.classList.toggle('is-active', i === active);
          slide.inert = true;
          slide.setAttribute('aria-hidden', String(i !== active));
          let text = 0, lift = 12;
          if (selected !== null) { text = i === selected ? 1 : 0; lift = 0; }
          else if (i === base) { text = 1 - smooth(Math.min(1, blend * 2)); lift = -10 * (1 - text); }
          else if (i === base + 1) { text = smooth(Math.max(0, blend * 2 - 1)); lift = 12 * (1 - text); }
          const copy = this.stepCopies[i];
          copy.style.setProperty('--lvso-text', String(text));
          copy.style.setProperty('--lvso-lift', `${this.mobile.matches ? 0 : lift}px`);
          copy.classList.toggle('is-active', i === active);
          copy.inert = i !== active;
          copy.setAttribute('aria-hidden', String(i !== active));
        });
        this.buttons.forEach((button, i) => {
          if (i === active) button.setAttribute('aria-current', 'step');
          else button.removeAttribute('aria-current');
        });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        cancelAnimationFrame(this.tick);
        this.controller?.abort();
        this.dockObserver?.disconnect();
        this.observer?.disconnect();
        this.parentObserver?.disconnect();
        this.bridge(true);
        this.shared?.remove();
        this.controller = null;
        this.tick = 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
